import moment from 'moment'

import { AccountCodesAPI } from '@webapp/api/AccountCodesAPI'
import { AddressAPI } from '@webapp/api/AddressAPI'
import { CardmanagementCardAPI } from '@webapp/api/CardManagementCardAPI'
import { type Address } from '@webapp/models/Address'
import { PayCardStatuses } from '@webapp/models/enums/PayCardStatus'
import {
  type AccountCode,
  type Currency,
  type Department,
  type Location,
  type PayCardholder,
  type User,
  type Vendor,
} from '../../../models'
import { ApiClient } from '../../../services/api'
import { type FilterManagerResolveFunction } from '../types'

interface DefaultFilterManagerResolvers {
  user: FilterManagerResolveFunction<User>
  userV2: FilterManagerResolveFunction<User>
  department: FilterManagerResolveFunction<Department>
  location: FilterManagerResolveFunction<Location>
  pref_vendor: FilterManagerResolveFunction<Vendor>
  currency: FilterManagerResolveFunction<Currency>
  address: FilterManagerResolveFunction<Address>
  moment: FilterManagerResolveFunction<moment.Moment>
  cardholder_user: FilterManagerResolveFunction<PayCardholder>
  accountCode: FilterManagerResolveFunction<AccountCode>
}

export const FilterManagerResolver: DefaultFilterManagerResolvers = {
  user: (userID) => {
    return ApiClient.get<User>(`/api/v3/users/${userID}/basic/`)
      .then((res) => res.data)
      .then((user) => user)
  },
  userV2: (userID) => {
    return ApiClient.get<User>(`/api/v3/users/${userID}/basic/`)
      .then((res) => res.data)
      .then((user) => user)
  },
  department: (departmentID) => {
    return ApiClient.get(`/api/v3/departments/${departmentID}/`)
      .then((res) => res.data)
      .then((department) => department)
  },
  location: (locationID) => {
    return ApiClient.get(`/api/v3/locations/${locationID}/`)
      .then((res) => res.data)
      .then((location) => location)
  },
  pref_vendor: (vendorID) => {
    return ApiClient.get(`/api/v3/vendors/${vendorID}/`)
      .then((res) => res.data)
      .then((vendor) => vendor)
  },
  currency: (currencyID) => {
    return ApiClient.get<Currency>(`/api/v2/currencies/${currencyID}/`)
      .then((res) => res.data)
      .then((currency) => currency)
  },
  address: (addressId) => {
    return AddressAPI.getAddress(addressId).then((res) => res.data)
  },
  moment: (date) => {
    return moment(date)
  },
  cardholder_user: (userID) => {
    return CardmanagementCardAPI.getCardByCardholderUser(userID, {
      require_activation: false,
      status: PayCardStatuses.ACTIVE,
      show_all: true,
    })
      .then((res) => res.data)
      .then((cards) => {
        if (cards && cards[0]) {
          return cards[0].cardholder
        } else {
          return null
        }
      })
  },
  accountCode: (accountCodeID) => {
    return AccountCodesAPI.getAccountCodeDetails(
      parseInt(accountCodeID, 10)
    ).then((res) => res.data)
  },
}
